import { Widget, WidgetSettingType } from '../base/widget/WidgetInterface'
import { WidgetHeightType, WidgetType } from '../base/widget/WidgetTypes'

export const WidgetVehicleStatusHistory: Widget = {
  type: WidgetType.vehicleStatusHistory,
  title: 'Änderungsverlauf aller Fahrzeuge',
  defaultSize: 8,
  minSize: 4,
  maxSize: 0,
  defaultHeightType: WidgetHeightType.automatic,
  icon: 'CarBack',
  dataInitializer: 'loadVehicleStatusHistory',
  customSettings: {
    settings: {
      showTitle: { type: WidgetSettingType.checkbox, title: 'Widget Titel anzeigen', checked: false },
      vehicles: { type: WidgetSettingType.custom, data: {}, template: 'custom/SettingsPanelCustomVehicleStatusHistoryVehicles' },
      maxlength: { type: WidgetSettingType.selectbox, title: 'Maximale Anzahl an Einträgen', value: '5', options: [
          { label: 'Unbegrenzt', value: -1 },
          { label: '5 Einträge', value: 5 },
          { label: '10 Einträge', value: 10 },
          { label: '15 Einträge', value: 15 },
          { label: '15 Einträge', value: 20 },
          { label: '15 Einträge', value: 25 }
      ] }
    },
    sections: [
      {
        label: 'Filter',
        settings: ['maxlength']
      },
      {
        label: 'Fahrzeuge',
        settings: ['vehicles']
      }
    ]
  }
}

export default WidgetVehicleStatusHistory
